import useOcapiSite from './useOcapiSite'
import {useMemo} from 'react'
import {isD2BCustomer} from '../utils/d2b-utils'
import {useCurrentCustomer} from './use-current-customer'

/**
 * Checks if d2b is enabled and current customer is d2b Customer
 *
 * @return {enabled} - isD2BCustomer
 *
 * */
export const useD2BCustomer = () => {
    const {data: customer} = useCurrentCustomer()
    const {d2bEnabled} = useOcapiSite()
    return useMemo(() => {
        return {enabled: isD2BCustomer(d2bEnabled, customer)}
    }, [customer, d2bEnabled])
}
